<template>
  <v-dialog
    v-model="modalAction"
    max-width="1000"
    scrollable
    @keydown="executeModalShowApprovers"
    @click:outside="executeModalShowApprovers"
  >
    <v-card>
      <div class="p-4 pb-0" v-if="currentRequest">
        <h5>
          Aprobadores de Solicitud con Cesta de Compra:
          <b>{{ currentRequest.sale_order }}</b>
        </h5>
      </div>
      <hr />
      <v-card-text>
        <v-tabs v-model="tab" fixed-tabs class="mt-4">
          <v-tab
            key="approvers"
            id="approvalList"
            v-if="
              currentRequest &&
                currentRequest.approval_request &&
                !currentRequest.approval_request.rejected
            "
          >
            Aprobadores de la Solicitud
          </v-tab>
          <v-tab
            key="approversOc"
            v-if="
              currentRequest &&
                currentRequest.approval_request &&
                !currentRequest.approval_request.rejected &&
                currentRequest.approval_request.sale_approvers &&
                currentRequest.approval_request.sale_approvers.length
            "
            id="approvalList"
          >
            Aprobadores de la OC
          </v-tab>
          <v-tab
            key="reasonReject"
            v-if="
              currentRequest &&
                currentRequest.approval_request &&
                currentRequest.approval_request.rejected
            "
          >
            Motivo de Rechazo de la Solicitud
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" v-if="currentRequest">
          <v-tab-item
            key="approvers"
            v-if="
              currentRequest &&
                currentRequest.approval_request &&
                !currentRequest.approval_request.rejected
            "
          >
            <Approvers
              v-if="currentRequest"
              :currentRequestMaterials="currentRequest.approval_request"
            ></Approvers>
          </v-tab-item>
          <v-tab-item
            key="approversOc"
            v-if="
              currentRequest &&
                currentRequest.approval_request &&
                !currentRequest.approval_request.rejected &&
                currentRequest.approval_request.sale_approvers &&
                currentRequest.approval_request.sale_approvers.length
            "
          >
            <approvers-oc
              v-if="currentRequest"
              :currentRequestMaterials="currentRequest.approval_request"
            ></approvers-oc>
          </v-tab-item>
          <v-tab-item
            key="reasonReject"
            v-if="
              currentRequest &&
                currentRequest.approval_request &&
                currentRequest.approval_request.rejected
            "
          >
            <reason-reject
              :reasonReject="currentRequest.approval_request.rejected_comment"
              :dateRejected="currentRequest.approval_request.rejected_at"
              :rejectedBy="currentRequest.approval_request.rejected_by"
            ></reason-reject>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" outlined @click="executeModalShowApprovers">
          <small> Cerrar </small>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import Approvers from "@/components/proyectos/lugarInstalacion/lugarSolicitudMaterial/approveRequests/Approvers.vue";
import ApproversOc from "@/components/proyectos/lugarInstalacion/lugarSolicitudMaterial/approveRequests/ApproversOc.vue";
import ReasonReject from "@/components/proyectos/lugarInstalacion/lugarSolicitudMaterial/approveRequests/ReasonReject.vue";

export default {
  components: { Approvers, ApproversOc, ReasonReject },
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalShowApprovers: {
      type: Function,
      default: () => {},
    },
    currentRequest: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tab: "approvers",
    };
  },
  methods: {
    executeModalShowApprovers($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalShowApprovers($event);
      }
    },
  },
};
</script>

<style></style>
